import useService from '@modules/ServiceModule/useService';

const SessionsPanel = () => {
  const { sessions } = useService();
  return (
    <div>
      <pre>{JSON.stringify(sessions, undefined, 2)}</pre>
    </div>
  );
};

export default SessionsPanel;
